import { ExperienceTimeFormat } from '@/types/gql.generated';
import { SidebarRowSelect } from '../SidebarRowSelect';
import { useCustomizeControl } from '../useCustomizeControl';

// Ordered least → most detailed. Labels mirror exactly what an event renders
// for that format (see formatTime.renderExact).
const TIME_FORMAT_CONFIGS = [
  { id: ExperienceTimeFormat.TwelveHourNoMeridiem, label: '9 – 3' },
  { id: ExperienceTimeFormat.TwelveHourCompact, label: '9a – 3p' },
  { id: ExperienceTimeFormat.HourOnly, label: '9 am – 3 pm' },
  { id: ExperienceTimeFormat.TwelveHour, label: '9:00 am – 3:00 pm' },
  { id: ExperienceTimeFormat.TwentyFourHour, label: '09:00 – 15:00' },
];

export const TimeFormatSelect = () => {
  const { register } = useCustomizeControl();

  return (
    <SidebarRowSelect
      minW="180px"
      options={TIME_FORMAT_CONFIGS}
      {...register('child', 'timeFormat')}
    />
  );
};
